import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { RouteSheetUtilService } from "./RouteSheetUtil.service";
import { Subscription } from "rxjs";
import { RouteSheetLocationDTO } from "../models/RouteSheetLocationDTO";
import { LocationCategoryDTO } from "src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO";

@Injectable({
  providedIn: "root",
})
export class RouteSheetService{

  public isLoadingList: boolean = false;

  //para panel related details como popup
  public dialogDetailsRef: any = null;
  keys: string[] = [];
  values: string[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];

  isForceReload: boolean = false;

  location_details_subscription: Subscription;
  location_route_subscription: Subscription;

  constructor(
    private routeSheetUtilService: RouteSheetUtilService,
  ) {
  }

  CreateLayers(locationCategory: LocationCategoryDTO) {
      this.routeSheetUtilService.CreateLayers(locationCategory);
  }

  openRouteSheetDetailsPopup( routeSheetLocation: any, parentCoordX: string, parentCoordY: string) {
      this.routeSheetUtilService.openRouteSheetDetailsPopup(routeSheetLocation, parentCoordX, parentCoordY);
  }

  async setRouteSheetLayers(routeGeoJson: string, locationGeoJson: string, parentCategory: LocationCategoryDTO, childCategory: LocationCategoryDTO): Promise<void> {
    return await this.routeSheetUtilService.setRouteSheetLayers(routeGeoJson, locationGeoJson, parentCategory, childCategory);
  }

  clearRouteSheetLayers(parentCategoryName: string): void {
    this.routeSheetUtilService.clearRouteSheetLayers(parentCategoryName);
  }
}
